import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {OccupationalProfile} from '../shared/occupational-profile';

@Component({
    selector: 'occupational-profile-competences',
    templateUrl: './occupational-profile-competences.component.html',
    styleUrls: ['./occupational-profile-competences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileCompetencesComponent {

    @Input()
    public occupationalProfile!: OccupationalProfile;

    hasCompetences(occupationalProfile: OccupationalProfile): boolean {
        return this.hasEssentialCompetences(occupationalProfile) || this.hasOptionalCompetences(occupationalProfile)
    }

    hasEssentialCompetences(occupationalProfile: OccupationalProfile): boolean {
		if (!occupationalProfile.essentialCompetences) return false;
        return occupationalProfile.essentialCompetences && occupationalProfile.essentialCompetences.length > 0;
    }

    hasOptionalCompetences(occupationalProfile: OccupationalProfile): boolean {
		if (!occupationalProfile.optionalCompetences) return false;
        return occupationalProfile.optionalCompetences && occupationalProfile.optionalCompetences.length > 0;
    }

    hasSoftSkills(occupationalProfile: OccupationalProfile): boolean {
		if (!occupationalProfile.softSkills) return false;
        return occupationalProfile.softSkills && occupationalProfile.softSkills.length > 0;
    }
}
